export const isMarketPlace = true
export const isMarginOnProductLevel = true
export const shippingOnCategoryLevel = false
export const maxWarehouseQty = 1000000
export const pageRangeDisplayed = 2
export const isAdharCardAllowed = false
export const isShippingOnCat = false
export const isSellerWithGST = true
export const isAllowOneProductMultipleSeller = false
export const isAllowPriceVariant = true
export const isAllowWarehouseManagement = true
export const isAllowExpiryDate = false
export const currencyIcon = '₹'
export const isAllowMultipleGST = true
export const isInventoryModel = false
export const isAllowCommissionInVariant = true
export const isSellerPanel = false

export const fontSizeConfig = {
  options: ['tiny', 'small', 'big', 'default']
}

export const headingStyles = {
  options: [
    { model: 'paragraph', title: 'Normal' },
    { model: 'heading1', view: 'h2', title: 'Heading 2' },
    { model: 'heading2', view: 'h3', title: 'Heading 3' },
    { model: 'heading3', view: 'h4', title: 'Heading 4' },
    { model: 'heading4', view: 'h5', title: 'Heading 5' },
    { model: 'heading5', view: 'h6', title: 'Heading 6' }
  ]
}

export const _orderStatus_ = {
  partial: 'Partial',
  cancelled: 'Cancelled',
  placed: 'Placed',
  confirmed: 'Confirmed',
  packed: 'Packed',
  ship: 'Shipped',
  delivered: 'Delivered',
  returned: 'Returned',
  returnRejected: 'Return Rejected',
  returnRequest: 'Return Requested',
  returnApproved: 'Return Approved',
  replaced: 'Replaced',
  replaceRequest: 'Replace Requested',
  replaceRejected: 'Replace Rejected',
  replaceApproved: 'Replace Approved',
  partialDelivered: 'Partial Delivered',
  partialConfirmed: 'Partial Confirmed',
  partialPacked: 'Partial Packed',
  partialShipped: 'Partial Shipped',
  exchanged: 'Exchanged',
  initiate: 'Initiate',
  failed: 'Failed'
}

export const productStatus = [
  { value: 'Active', label: 'Active' },
  {
    value: 'Request for Approval',
    label: 'Request for Approval'
  },
  {
    value: 'Bulk Stock Upload',
    label: 'Bulk Stock Upload'
  },
  {
    value: 'Bulk Upload',
    label: 'Bulk Upload'
  },
  {
    value: 'Poor Image Quality',
    label: 'Poor Image Quality'
  },
  {
    value: 'Pricing-Very High',
    label: 'Pricing-Very High'
  },
  {
    value: 'Pricing-Very Low',
    label: 'Pricing-Very Low'
  },
  {
    value: 'Pricing-High Discount',
    label: 'Pricing-High Discount'
  },
  {
    value: 'Restricted Image',
    label: 'Restricted Image'
  },
  {
    value: 'Restricted Keyword',
    label: 'Restricted Keyword'
  },
  {
    value: 'Feature Missing',
    label: 'Feature Missing'
  },
  { value: 'High Returns', label: 'High Returns' },
  {
    value: 'Multiple Issues',
    label: 'Multiple Issues'
  }
]

export const redirectTo = [
  { value: 'Product List', label: 'Product List' },
  {
    value: 'Static Page',
    label: 'Static Page'
  },
  {
    value: 'Landing Page',
    label: 'Landing Page'
  },
  {
    value: 'Collection Page',
    label: 'Collection Page'
  },
  {
    value: 'Other Links',
    label: 'Other Links'
  }
]

export const ckEditorConfig = {
  toolbar: [
    '|',
    'bold',
    'italic',
    '|',
    'bulletedList',
    'numberedList',
    '|',
    'undo',
    'redo'
  ]
}

export const _offerType_ = [
  { label: 'Percentage', value: 'percentage discount' },
  { label: 'Flat Discount', value: 'flat discount' },
  { label: 'Free Shipping', value: 'free shipping' }
]

export const _status_ = [
  {
    label: 'Active',
    value: 'Active'
  },
  {
    label: 'Inactive',
    value: 'Inactive'
  }
]

export const videoFormats = [
  'mp4',
  'avi',
  'mov',
  'mkv',
  'wmv',
  'flv',
  'webm',
  'mpeg',
  '3gp'
]

export const chargesIn = [
  {
    label: 'Absolute',
    value: 'Absolute'
  },
  {
    label: 'Percentage',
    value: 'Percentage'
  }
]
